// AppContainer.js
import React from "react";
import { Layout } from "antd";
import { Routes, Route } from "react-router-dom";
import "./container.scss";
import routes from "../../Pages/routes";
const { Content } = Layout;

const AppContainer = ({ showSideNav }) => {
  return (
    <Content
      className="site-layout-background"
      style={{
        margin: showSideNav && "24px 16px",
        flex: showSideNav && 1,
      }}
    >
      <Routes>
        {routes.routes.map((list, index) => (
          <Route
            key={index}
            path={list.path}
            element={
              <Layout>
                {list.element}
              </Layout>
            }
          />
        ))}
      </Routes>
    </Content>
  );
};

export default AppContainer;
